"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseSocialContentService = /** @class */ (function () {
    function BaseSocialContentService(groupId, contextTokenRepository, apiClient) {
        this.groupId = groupId;
        this.contextTokenRepository = contextTokenRepository;
        this.apiClient = apiClient;
        this.apiClient.interceptors.request.use(this.contextTokenInterceptor.bind(this));
    }
    BaseSocialContentService.prototype.contextTokenInterceptor = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contextToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContextToken()];
                    case 1:
                        contextToken = _a.sent();
                        config.params = tslib_1.__assign({ contextToken: contextToken }, config.params);
                        return [2 /*return*/, config];
                }
            });
        });
    };
    BaseSocialContentService.prototype.getContextToken = function () {
        return this.contextTokenRepository.getContextToken(this.groupId);
    };
    return BaseSocialContentService;
}());
exports.BaseSocialContentService = BaseSocialContentService;
//# sourceMappingURL=base-social-content.service.js.map